// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"648":"da43650818832da1","705":"2653c9e4038c5996","835":"a392ea956d41824e"}[chunkId] + ".js";
};